export enum Roles {
  Admin = "admin",
  Moderator = "moderator",
}
